import { MomentInput } from 'moment';
import StateManagerInstance from '../../../user/stateManager';
import { NCD_POLICY_NOTIFICATION_ACTION } from '../../../newClientDelivery.constants';

export interface NCDCancellationPolicyNotification {
  creation_time: MomentInput;
  persistent: true;
  providerId: number;
  type: 'ncd_cancellation_policy';
  uuid: 'ncd-cancellation-policy-notification';
}

export const shouldShowNcdCancellationPolicyNotification = async () => {
  const hasAcceptedNcdPolicy = await StateManagerInstance.getActionValue(
    NCD_POLICY_NOTIFICATION_ACTION,
  );
  return !hasAcceptedNcdPolicy;
};

export const createNcdCancellationPolicyNotification = (
  providerId: number,
): NCDCancellationPolicyNotification => ({
  creation_time: new Date(),
  persistent: true,
  providerId,
  type: 'ncd_cancellation_policy',
  uuid: 'ncd-cancellation-policy-notification',
});
